import React from 'react';
import './TelemetryCard.scss';
import TelemetryCardV2 from './TelemetryCardV2';
import { Spinner, Gallery } from '@patternfly/react-core';
import PropTypes from 'prop-types';

const TelemetryCardListV2 = ({ assetId, telemetryModelValues, isLoading, hideChart = false, header = null }) => {
  if (isLoading) {
    return <Spinner size="md"/>;
  }


  return (
    <>
      { header }
      <Gallery hasGutter>
        { telemetryModelValues.map((model) => {
          return (
            <TelemetryCardV2
              key={model.name}
              telemetrySchema={model}
              telemetryValue={model.value}
              assetId={assetId}
              hideChart={hideChart}
            />
          );
        }) }
      </Gallery>
    </>
  );
};

TelemetryCardListV2.propTypes = {
  assetId: PropTypes.string,
  telemetryModelValues: PropTypes.array
};

export default TelemetryCardListV2;
